export const ADMIN_GET_PRODUCTS = 'ADMIN_GET_PRODUCTS'
export const ADMIN_ADD_PRODUCT = 'ADMIN_ADD_PRODUCT'
export const ADMIN_UPDATE_PRODUCT = 'ADMIN_UPDATE_PRODUCT'
export const ADMIN_DELETE_PRODUCT = 'ADMIN_DELETE_PRODUCT'
